import * as React from 'react'

const SvgMonitoringIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.875 6.25h4.375V7.5h-4.375V6.25zm0 3.125h4.375v1.25h-4.375v-1.25zm0 3.125h4.375v1.25h-4.375V12.5zM17.5 3.125h-15c-.69 0-1.25.56-1.25 1.25v11.25c0 .69.56 1.25 1.25 1.25h15a1.252 1.252 0 001.25-1.25V4.375c0-.69-.56-1.25-1.25-1.25zm-15 1.25H7v11.25H2.5V4.375zm5.75 11.25V4.375h9.25l.001 11.25H8.25z"
      fill="#163250"
    />
    <path fill="#163250" d="M2 4h5v12H2z" />
    <path
      d="M3 7.881L3.881 7l3.125 3.125-3.125 3.125L3 12.369l2.237-2.244L3 7.881z"
      fill="#fff"
    />
  </svg>
)

export default SvgMonitoringIcon
